import script from "./messagesContent.linux.vue?vue&type=script&setup=true&lang=ts"
export * from "./messagesContent.linux.vue?vue&type=script&setup=true&lang=ts"

import "./messagesContent.linux.vue?vue&type=style&index=0&id=2db9df5f&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db9df5f"]])

export default __exports__